"use client";

import * as React from "react";

import { cn } from "@/utils";

export type CompactInputProps = Omit<
  React.InputHTMLAttributes<HTMLInputElement>,
  "size"
> & {
  startAdornment?: React.ReactNode;
  endAdornment?: React.ReactNode;
};

const CompactInput = React.forwardRef<HTMLInputElement, CompactInputProps>(
  function CompactInput(
    { startAdornment, endAdornment, className, ...props },
    ref,
  ) {
    return (
      <label className="relative block">
        {startAdornment && (
          <span className="pointer-events-none absolute left-2 top-1/2 -translate-y-1/2 text-garnet/70">
            {startAdornment}
          </span>
        )}

        <input
          ref={ref}
          {...props}
          className={cn(
            "h-full rounded-md bg-fog text-garnet text-sm px-2 placeholder-garnet/50 outline-none",
            startAdornment ? "pl-8" : "",
            endAdornment ? "pr-8" : "",
            className,
          )}
        />
        {/* Custom placeholder for button input type */}
        {props.type === "button" && !props.value && props.placeholder && (
          <span className="absolute left-2 top-1/2 -translate-y-1/2 text-garnet/50 pointer-events-none select-none">
            {props.placeholder}
          </span>
        )}

        {endAdornment && (
          <span className="absolute right-2 top-1/2 -translate-y-1/2 inline-flex">
            {endAdornment}
          </span>
        )}
      </label>
    );
  },
);

CompactInput.displayName = "CompactInput";
export default CompactInput;
